import { Link } from "react-router-dom";
import { Frame } from "@/components/site/Frame";
import { Reveal } from "@/components/site/Motion";

export const NextProject = ({ project: p }) => (
  <section aria-label="Next project" className="px-6 pb-24 pt-10 lg:px-12 lg:pb-32">
    <Reveal>
      <Link to={`/work/${p.slug}`} data-testid="next-project-link" className="group grid grid-cols-1 items-end gap-8 border-t border-ink pt-8 md:grid-cols-12">
        <div className="md:col-span-7">
          <p className="label mb-6 text-mute">Next project — {p.no}</p>
          <p className="font-display text-[clamp(2.4rem,6vw,6.5rem)] font-medium leading-[0.95] tracking-[-0.05em]">
            {p.titleLines.map((l) => <span key={l} className="block">{l}</span>)}
          </p>
          <p className="mt-6 inline-flex items-center gap-3 text-sm font-medium">
            <span className="u-link">View case study</span>
            <span className="transition-transform duration-500 group-hover:translate-x-1" aria-hidden="true">→</span>
          </p>
        </div>
        <div className="md:col-span-4 md:col-start-9">
          <Frame {...p.cover} ratio="4/3" innerClass="transition-transform duration-[1400ms] ease-[cubic-bezier(.22,1,.36,1)] group-hover:scale-[1.04]" />
        </div>
      </Link>
    </Reveal>
  </section>
);
